/**
 * Picking images out of Blizzard's character-media `assets` array.
 *
 * The array is keyed, and its contents vary per character. Sampling the Terra roster
 * returns two shapes:
 *
 *   ["avatar", "main-raw"]              ~55% of characters
 *   ["avatar", "inset", "main-raw"]     ~45% of characters
 *
 * That is why indexing by position is wrong. Reading assets[2] for the full render only
 * finds it on characters that happen to have an "inset", and silently falls back to the
 * 2D avatar for everyone else — even though every character sampled did have a
 * "main-raw" render available.
 *
 * Always select by key.
 */

/** First asset matching any of `keys`, in preference order. */
const pickByKey = (mediaLinks, keys) => {
  if (!Array.isArray(mediaLinks)) return null;
  for (const key of keys) {
    const match = mediaLinks.find((asset) => asset?.key === key);
    if (match?.value) return match.value;
  }
  return null;
};

/**
 * Full-body character render. "main-raw" is what the profile API returns today; "main"
 * is accepted too, since Blizzard has used it and it costs nothing to tolerate.
 * Falls back to the smaller images so something always shows.
 */
export const getCharacterRender = (mediaLinks) =>
  pickByKey(mediaLinks, ["main-raw", "main", "inset", "avatar"]);

/** Small headshot, for lists and nav. */
export const getCharacterAvatar = (mediaLinks) =>
  pickByKey(mediaLinks, ["avatar", "inset", "main-raw", "main"]);
